class CalculatorController {
  constructor() {
    this.name = 'calculator';
    this.page = 0;
    // console.log(this);
  }

  /**
   * updates current page of the calculator. Sets the page to the index passed
   * @param index
   */
  updatePage(index){
    if(index >= this.pages.length){
      this.page = this.pages.length - 1;
    }else if(index < 0){
      this.page = 0;
    }else{
      this.page = index;
    }
  }

}

export default CalculatorController;



// WEBPACK FOOTER //
// ./client/app/components/calculator/calculator.controller.js